import React, { useState, useCallback, useEffect, useMemo } from 'react';
import { unstable_ClassNameGenerator as ClassNameGenerator } from '@mui/material/className';
import { ThemeProvider as MuiThemeProvider, StyledEngineProvider } from '@mui/material/styles';
import CssBaseline from '@mui/material/CssBaseline';
import GlobalStyles from 'components/v2/GlobalStyles';
import { ThemeContext } from './ThemeContext';
import { agentTheme } from './agentTheme';

ClassNameGenerator.configure(componentName => `muitrvl-${componentName}`);

const AgentThemeProvider = ({ agency, children }) => {
  const [customizations, setCustomizationsState] = useState({});

  useEffect(() => {
    setCustomizationsState(agency || {});
  }, [agency]);

  const setCustomization = useCallback((path, value, overrides = null) => {
    const _overrides = overrides ? overrides : { [path]: value };
    setCustomizationsState(prev => ({ ...prev, ..._overrides }));
  }, []);

  const contextValue = useMemo(
    () => ({
      customizations,
      setCustomization,
    }),
    [customizations, setCustomization],
  );

  return (
    <StyledEngineProvider injectFirst>
      <MuiThemeProvider theme={agentTheme}>
        <CssBaseline />
        <GlobalStyles />
        <ThemeContext.Provider value={contextValue}>{children}</ThemeContext.Provider>
      </MuiThemeProvider>
    </StyledEngineProvider>
  );
};

export default AgentThemeProvider;
